import { dateTimeBR } from "../../lib/format";
import { Card } from "../common";

const TXT = {
  config_created: "Configuração financeira criada", config_changed: "Condições comerciais alteradas", invoice_closed: "Cobrança fechada (quantidade congelada)",
  charge_registered: "Dados de cobrança registrados", invoice_adjusted: "Cobrança ajustada", invoice_sent: "Cobrança enviada ao cliente", invoice_canceled: "Cobrança cancelada",
  payment_registered: "Fatura marcada como paga", payment_reversed: "Confirmação de pagamento desfeita", due_soon: "Alerta: vence em 3 dias", due_today: "Alerta: vence hoje", overdue: "Alerta: cobrança vencida",
  suspension_pending: "Alerta: suspensão próxima", suspended: "Serviço suspenso", reactivated: "Serviço reativado",
  invoice_corrected: "Cobrança corrigida (regra de faturamento)", billing_divergence: "Divergência sinalizada em fatura paga",
};

const detail = (e) => {
  const m = e.metadata || {};
  if (m.amount !== undefined && m.amount !== null && e.event_type.startsWith("payment")) return `${m.competence ? `${m.competence.slice(5)}/${m.competence.slice(0, 4)} · ` : ""}R$ ${Number(m.amount).toFixed(2).replace(".", ",")}${m.paid_at ? ` · pago em ${m.paid_at.split("-").reverse().join("/")}` : ""}${m.method ? ` · ${m.method}` : ""}${m.reference ? ` · ${m.reference}` : ""}${m.reason ? ` · motivo: ${m.reason}` : ""}`;
  if (m.reason) return m.reason;
  if (m.before && m.after) return Object.keys(m.after).map((k) => `${k}: ${m.before[k] ?? "—"} → ${m.after[k] ?? "—"}`).join(" · ");
  if (m.to) return `Para ${m.to.join(", ")}`;
  if (m.amount) return `R$ ${Number(m.amount).toFixed(2).replace(".", ",")}${m.reference ? ` · ${m.reference}` : ""}`;
  return "";
};

export function FinanceEvents({ events }) {
  return (
    <Card className="p-5" testid="fin-events">
      <div className="text-sm font-semibold mb-3">Histórico financeiro</div>
      <ol className="space-y-2 text-xs">{events.map((e) => (
        <li key={e.id} className="border-l-2 border-slate-200 pl-3" data-testid={`fin-event-${e.event_type}`}>
          <div className="text-slate-500">{dateTimeBR(e.created_at)} · {e.created_by}</div>
          <div className="text-slate-800"><b>{TXT[e.event_type] || e.event_type}</b>{detail(e) ? ` — ${detail(e)}` : ""}</div>
        </li>))}
        {!events.length && <li className="text-slate-500">Sem eventos.</li>}</ol>
    </Card>);
}
